import { VALUES, LOCALSTORAGE_KEYS } from 'utils/constants'
import { getFromApi } from 'actions'
import AuthorizedURLs from 'services/AuthorizedURLService'

export async function getAuthorizationDataAction(dispatch, history, entity) {
   const authorizedUrlService = new AuthorizedURLs()
   const url = `${process.env.REACT_APP_AUTHORIZATION_API}/user/profile${entity ? '?entity_nit=' + entity : ''}`
      const authData = await getFromApi(url)
      if (authData) {
         await authorizedUrlService.setAppUrls(authData?.menus)
         const { resources, operations } = authData
         let authorizedOptions = {}
         if (
            !!resources[VALUES.APP_RESOURCE_CODE] &&
            !!operations[VALUES.APP_RESOURCE_CODE]
         ) {
            const authorizedOperations = operations[VALUES.APP_RESOURCE_CODE]
            if (authorizedOperations.length) {
               const isAuthorized = optionCode =>
                  authorizedOperations.some(op => op.code === optionCode)
               authorizedOptions = {
                  addVideoTutoriales: isAuthorized(VALUES.VIDEO_TUTORIALS_CODE),
                  addRegulatons: isAuthorized(VALUES.REGULATIONS_CODE)
               }
            }
         }
         localStorage.setItem(
            LOCALSTORAGE_KEYS.USER_SETTINGS,
            JSON.stringify(authData)
         )
         dispatch({
            type: 'UPDATE_SESSION_DATA',
            payload: { settings: authData, authorizedOptions }
         })
         dispatch({ type: 'CLOSE_SPINNER' })
         if (!authData.policiesAccepted && authData.type === 'E') {
            history.push('/site-policies')
         } else {
            history.push('/dashboard')
         }
      }

}
